import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { InvoiceService } from '../../Services/invoice.service';
import { InvoiceHistoryDate } from '../../Services/invoiceAddendumListViewModel';

@Component({
  selector: 'app-download-autopay-report',
  templateUrl: './download-autopay-report.component.html',
  styleUrls: ['./download-autopay-report.component.less']
})
export class DownloadAutopayReportComponent implements OnInit {
  public processing : boolean = false;
  invoicingMonths : number[] = [1,2,3,4,5,6,7,8,9,10,11,12];
  invoicingYears : number[] = [2020, 2021, 2022, 2023, 2024,2025];
  
  
  selectedYear : number;
  selectedMonth : number;
  constructor(
    public readonly modalService: NgbModal,
    private toasterService: ToastrService,
    private readonly invoiceService: InvoiceService,
    private fileDownload: FileDownloadService
  ) { }

  ngOnInit() {
    
  }

  download() : void {
    this.processing = true;
    this.invoiceService.downloadAutoPaymentCSV(this.selectedMonth, this.selectedYear).subscribe((res : Blob) => {
      if (res) {
        // this.fileDownload.HandleFileDownload(res, 'csv', `${this.selectedYear} - ${this.selectedMonth} AutoPay Report.csv`);
        this.fileDownload.HandleFileDownload(res, 'csv', `WRT-RIQ Payments_${this.selectedYear}-${this.selectedMonth}.csv`);

        this.modalService.dismissAll();
      } else {
        this.toasterService.info('No autopay data found.');
      }
      this.processing = false;
    },
    (err) => {
      this.toasterService.error('There was an error fetching autopay report data.', '', { disableTimeOut: true, closeButton: true });
      this.processing = false;
    });
  }

  cancel() : void {
    this.modalService.dismissAll();
  }

  getMonthName(month:number): string{
    return moment().month(month -1).format('MMMM');
  }

}
